import {
  CUBE_AGGREGATE_INTERACTION,
  CUBE_AGGREGATE_INTERACTION_EMPLOYEE,
  CUBE_AGGREGATE_INTERACTION_FIELD_FORCE,
  CUBE_AGGREGATE_INTERACTION_PRODUCT,
} from '@/api/hcp/interaction/types';
import { LogicalAndFilter } from '@cubejs-client/core';
import { appendInteractionIndicationFilter } from './channelFilterHelpers';
import { AdditionalFilterState } from './hooks';

export const buildEmailFilters = (
  state: AdditionalFilterState,
  indicationOptionPaths: string[],
  isEmailJourneyInsightsEnabled: boolean,
): LogicalAndFilter => {
  const emailFilters: LogicalAndFilter = {
    and: [],
  };

  if (state?.emailCampaign?.length) {
    emailFilters.and.push({
      member: `${CUBE_AGGREGATE_INTERACTION}.email_name`,
      operator: 'equals',
      values: [...state.emailCampaign],
    });
  }
  if (state?.productLocal?.length) {
    emailFilters.and.push({
      member: `${CUBE_AGGREGATE_INTERACTION_PRODUCT}.product`,
      operator: 'equals',
      values: [...state.productLocal],
    });
  }
  appendInteractionIndicationFilter(emailFilters, state, indicationOptionPaths);
  if (state?.emailTopic?.length) {
    emailFilters.and.push({
      member: `${CUBE_AGGREGATE_INTERACTION}.activity_type`,
      operator: 'equals',
      values: [...state.emailTopic],
    });
  }
  if (state?.emailChannel?.length) {
    emailFilters.and.push({
      member: `${CUBE_AGGREGATE_INTERACTION}.email_diffusion`,
      operator: 'equals',
      values: [...state.emailChannel],
    });
  }

  if (isEmailJourneyInsightsEnabled) {
    if (state?.fieldForce?.length) {
      emailFilters.and.push({
        member: `${CUBE_AGGREGATE_INTERACTION_FIELD_FORCE}.field_force_code`,
        operator: 'equals',
        values: [...state.fieldForce],
      });
    }
    if (state?.rocheEmployee?.length) {
      emailFilters.and.push({
        member: `${CUBE_AGGREGATE_INTERACTION_EMPLOYEE}.employee_name`,
        operator: 'equals',
        values: [...state.rocheEmployee],
      });
    }
  }

  return emailFilters;
};
